<script setup lang="ts">
import { AlertCircleIcon, PauseCircleIcon, PlayIcon, XIcon } from '@gohighlevel/ghl-icons/24/outline';
import { HLTag } from '@platform-ui/highrise';
import { computed, h } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n()

interface Props {
  status: 'location_deleted' | 'location_paused' | 'schedule_paused' | 'schedule_active'
}

const props = defineProps<Props>()

const statusConfig = {
  location_deleted: {
    color: 'red',
    icon: XIcon,
    label: t('deleted'),
  },
  location_paused: {
    color: 'orange',
    icon: AlertCircleIcon,
    label: t('locationPaused'),
  },
  schedule_paused: {
    color: 'gray',
    icon: PauseCircleIcon,
    label: t('paused'),
  },
  schedule_active: {
    color: 'green',
    icon: PlayIcon,
    label: t('active'),
  }
}

const color = computed(() => statusConfig[props.status].color)
const icon = computed(() => statusConfig[props.status].icon)
const label = computed(() => statusConfig[props.status].label)
</script>
  
<template>
  <HLTag
    size="md"
    :color="color"
    :bordered="false"
    :round="true"
    :interactive="false"
  >
    <template #icon>
        <component :is="icon" aria-hidden="true" />
    </template>
    {{label}}
  </HLTag>
</template>
